import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ItineraryPage from './pages/ItineraryPage';
import Header from './components/Header';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/fluviacap" element={<><Header /><ItineraryPage /></>} />
        {/* Ajoutez ici d'autres routes pour les autres pages de votre application */}
      </Routes>
    </Router>
  );
}

export default App;
